<template>
  <div @click="closePopover" class="sidebar-content sidebar-content--sleeves">
    <h1 class="sidebar-title">Trim Color</h1>
    <h3 class="sidebar-subtitle" v-if="patternEditMode === false">Pick a Trim Pattern</h3>
    <ul class="trimPatterns" v-if="patternEditMode === false">
      <li
        class="pattern__item"
        :class="`pattern__item_${pattern.title}`"
        @click="patternEditModeOn(pattern)"
        v-for="pattern in patterns"
        :key="pattern.title"
      >
        <component :is="pattern.pattern"/>
      </li>
    </ul>
    <TrimModeDisplay
      v-if="patternEditMode === true"
      @patternEditModeOff="patternEditModeOff"
      :editingComponent="editingPattern.pattern"
      :isPatternColors="editingPattern.isColors"
    />
  </div>
</template>

<script>
import PatternA from '@/components/jacket/trims/trimPatterns/PatternA.vue';
import PatternB from '@/components/jacket/trims/trimPatterns/PatternB.vue';
import PatternC from '@/components/jacket/trims/trimPatterns/PatternC.vue';
import PatternD from '@/components/jacket/trims/trimPatterns/PatternD.vue';
import PatternE from '@/components/jacket/trims/trimPatterns/PatternE.vue';
import PatternF from '@/components/jacket/trims/trimPatterns/PatternF.vue';
import TrimModeDisplay from '@/components/jacket/trims/TrimModeDisplay.vue';
import { TRIM_PATTERNS } from '@/common/constants';

export default {
  name: 'TrimSidebar',
  components: {
    PatternA,
    PatternB,
    PatternC,
    PatternD,
    PatternE,
    PatternF,
    TrimModeDisplay
  },
  data () {
    return {
      patternEditMode: false,
      editingPattern: {},
      patterns: [
        {
          id: 0,
          title: 'A',
          pattern: TRIM_PATTERNS.PATTERN_A,
          isColors: {
            isBaseTrimsColor: true,
            isSecondaryTrimsColor: true,
            isFinishTrimsColor: false,
          }
        },
        {
          id: 1,
          title: 'B',
          pattern: TRIM_PATTERNS.PATTERN_B,
          isColors: {
            isBaseTrimsColor: true,
            isSecondaryTrimsColor: true,
            isFinishTrimsColor: true,
          }
        },
        {
          id: 2,
          title: 'C',
          pattern: TRIM_PATTERNS.PATTERN_C,
          isColors: {
            isBaseTrimsColor: true,
            isSecondaryTrimsColor: false,
            isFinishTrimsColor: false,
          }
        },
        {
          id: 3,
          title: 'D',
          pattern: TRIM_PATTERNS.PATTERN_D,
          isColors: {
            isBaseTrimsColor: true,
            isSecondaryTrimsColor: true,
            isFinishTrimsColor: true,
          }
        },
        {
          id: 4,
          title: 'E',
          pattern: TRIM_PATTERNS.PATTERN_E,
          isColors: {
            isBaseTrimsColor: true,
            isSecondaryTrimsColor: true,
            isFinishTrimsColor: false,
          }
        },
        {
          id: 5,
          title: 'F',
          pattern: TRIM_PATTERNS.PATTERN_F,
          isColors: {
            isBaseTrimsColor: true,
            isSecondaryTrimsColor: true,
            isFinishTrimsColor: true,
          }
        },
      ]
    };
  },
  methods: {
    closePopover () {
    },
    patternEditModeOn (pattern) {
      this.patternEditMode = true;
      this.editingPattern = pattern;
      this.$store.commit('design/setActiveTrimPattern', pattern.pattern);
    },

    patternEditModeOff () {
      this.patternEditMode = false;
      this.editingPattern = null;
    },
  }
};
</script>

<style scoped>
.trimPatterns {
  display: flex;
  flex-direction: column;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
}

.pattern__item {
  padding-top: 3px;
  position: relative;
  width: 166px;
  height: 200px;
  display: flex;
  justify-content: center;
  background-color: #1c539c;
  margin-bottom: 20px;
  &:after {
    content: "";
    position: absolute;
    color: white;
    left: 10px;
    bottom: 5px;
    font-size: 18px;
    font-weight: bold;
  }
}

.pattern__item_A {
  &:after {
    content: "A";
  }
}
.pattern__item_B {
  &:after {
    content: "B";
  }
}
.pattern__item_C {
  &:after {
    content: "C";
  }
}
.pattern__item_D {
  &:after {
    content: "D";
  }
}
.pattern__item_E {
  &:after {
    content: "E";
  }
}
.pattern__item_F {
  &:after {
    content: "F";
  }
}
</style>
